"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default={xs:"320px",sm:"544px",md:"767px",lg:"1025px",xl:"1272px"};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/breakpoints/breakpoints.js
// module id = 900
// module chunks = 0